import React, {useEffect, useState} from 'react';
import {Row} from 'react-bootstrap';
import { forceCheck } from 'react-lazyload';
import './style.css';

const base_button_style = {
	cursor: 'pointer',
	position: 'absolute', 
	backgroundColor: 'white',
	borderRadius: '50%',
	paddingLeft: 10,
	paddingRight: 10,
	paddingTop:4,
	paddingBottom: 4,
	boxShadow: '1px 1px 5px 0 rgba(0,0,0,0.15)'
}

const PenguinSlider = ({ children, id, height }) => {
	try {
		const [ show_back, set_show_back ] = useState(false);
		const [ show_forward, set_show_forward ] = useState(false);
		const [ slider_initialized, set_slider_initialized ] = useState(false);

		const scroll_forward = () => {
			try {
			    sideScroll({ direction: 'right', speed: 5, distance: 500, step: 10 });
			} catch(err) {
				console.log('error in scroll_forward --> ', err);
			}
		};


		const scroll_back = () => {
			try {
		    	sideScroll({ direction: 'left', speed: 5, distance: 500, step: 10 });
			} catch(err) {
				console.log('error in scroll_back --> ', err);
			}
		};

		const sideScroll = ({ direction, speed, distance, step, hide_front }) => {
		    var element = window.document.getElementById(id);
		    if(element){
			    var scrollAmount = 0;
			    var slideTimer = setInterval(() =>{
			        if (direction == 'left') {
			            element.scrollLeft -= step;
			        } else {
			            element.scrollLeft += step;
			        }

			        scrollAmount += step;
			        if (scrollAmount >= distance) {
						forceCheck();
			            window.clearInterval(slideTimer);
			        }
					// document.body.dispatchEvent(new CustomEvent('scroll'))       
					// window.dispatchEvent(new CustomEvent('scroll'))       
			    }, speed);
			}
		}

		const check_scroll_position = () => {
			try {
		   		var element = window.document.getElementById(id);
		   		if(element){
					if (element.scrollLeft > 0 && !show_back) {
						set_show_back(true);
					}

					if (element.scrollLeft < (element.scrollWidth - element.clientWidth) && !show_forward) {
						set_show_forward(true);
					}

					if (element.scrollLeft == (element.scrollWidth - element.clientWidth) && show_forward) {
			        	set_show_forward(false);
			        } else if (element.scrollLeft == 0 && show_back) {
			        	set_show_back(false)
			        }
			    }
			} catch(err) {
				console.log('error in on scroll ---> ', err)
			}
		}

		const set_initial_scroll_params = () => {
		   	try {
		   		var element = window.document.getElementById(id);
		   		// console.log('initind ---> ', element.clientWidth, element.scrollWidth)
		   		if (element && element.scrollWidth > element.clientWidth) {
		   			set_show_forward(true);
		   		}
		   	} catch (err) {
		   		console.log("error setting init params ---> ", err);
		   	}
		}

		useEffect(() => {
			if (!slider_initialized) {
				var debounced_initialization = setTimeout(() => {
					set_initial_scroll_params();
					window.clearTimeout(debounced_initialization);
				}, 1200)
			}
		}, [])

		return (
			<div style={{ position: 'relative' }}>
				<Row onScroll={check_scroll_position} id={id} className="penguin_slider" style={{ whiteSpace: 'nowrap', overflowX: 'hidden',position:'relative' }} >
					{children}
					{/*children.map(child => {
						return (<LazyLoad>{child}</LazyLoad>)
					})*/}
				</Row>
				<div onClick={scroll_back} style={{ ...base_button_style, display: show_back ? 'block': 'none', left: '-15px', top: height/2-10 }} > <span className="fa fa-chevron-left" /> </div>
				<div onClick={scroll_forward} style={{ ...base_button_style, display: show_forward ? 'block' : 'none', right: '-15px', top: height/2-10 }} > <span className="fa fa-chevron-right" /> </div>
			</div>
		)

	} catch(err) {
		console.log('penguin slider error --> ', err);
		return '';
	}
}

export default PenguinSlider;